<template>
  <ClientOnly>
    <Teleport to="body">
      <Transition name="modal">
        <div
          v-if="isOpen"
          class="fixed left-0 top-0 z-[1000] flex size-full flex-col items-center justify-center overflow-hidden overscroll-none"
          :class="$attrs.class"
        >
          <button
            class="absolute left-0 top-0 size-full bg-black/75 backdrop-blur-sm"
            @click="closeModal"
          />

          <main
            class="modal-container relative z-10 mx-auto max-w-none bg-background shadow-2xl belowTablet:size-full belowTablet:overflow-y-scroll tablet:size-[700px] desktop:size-[800px]"
          >
            <button
              class="absolute right-4 top-4 z-100 size-8 shrink-0 text-primary hover:text-primary-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
              aria-label="Close dialog"
              @click="closeModal"
            >
              <SpriteSymbol name="close" class="size-full" />
            </button>

            <div class="h-full px-size-6 tablet:p-size-4">
              <slot />
            </div>
          </main>
        </div>
      </Transition>
    </Teleport>
  </ClientOnly>
</template>

<script lang="ts" setup>
const props = defineProps<{
  modalId: string
  card?: boolean
  title?: string
  text?: string
}>()

const { activeModal, closeModal } = useModal()

const isOpen = computed(() => props.modalId === activeModal.value)
</script>

<style lang="postcss">
.modal-enter-active,
.modal-leave-active {
  @apply transition-all duration-300 ease-swing;

  .modal-container {
    @apply transition-all duration-300 ease-bounce;
  }
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;

  .modal-container {
    @apply translate-y-1/2 tablet:translate-y-9 tablet:scale-90;
  }
}

.modal-leave-from,
.modal-enter-to {
  opacity: 1;
}
</style>
